const crcTable: number[] = [];

for (let n = 0; n < 256; n++)
{
    let c = n;

    for (let k = 0; k < 8; k++)
    {
        if (c & 1)
        {
            c = 0xedb88320 ^ (c >>> 1);
        }
        else
        {
            c = c >>> 1;
        }
    }
    crcTable[n] = c;
}

function updateCrc(data: Uint8Array, previousCrc: number = 0): number
{
    let currentCrc = previousCrc ^ -1;

    for (let i = 0; i < data.length; i++)
    {
        currentCrc = crcTable[(currentCrc ^ data[i]) & 0xff] ^ (currentCrc >>> 8);
    }

    return currentCrc ^ -1;
}

export function calculateCrcFromChunks(chunks: Uint8Array[]): number
{
    let crc: number = 0;

    for (const data of chunks)
    {
        crc = updateCrc(data, crc);
    }

    return crc;
}
